import {get} from 'lodash';
import {createContext, useContext} from 'react';
import {useStaticQuery, graphql} from 'gatsby';

export const TranslationContext = createContext({});

export const useTranslation = () => {
  let translation = useContext(TranslationContext);

  const result = useStaticQuery(query);

  translation = JSON.parse(result.contentfulCommonJsonData.childContentfulCommonJsonDataDataJsonNode.internal.content);

  return {
    t: (key: string): string => {
      const content = get(translation, key);
      if (content)
        return content;

      return key;
    }
  };
};

const query = graphql`
  {
    contentfulCommonJsonData(contentful_id: { in: "45VrRxelLtuubuHmmieQus" }) {
      childContentfulCommonJsonDataDataJsonNode {
        internal {
          content
        }
      }
    }
  }
`;
